export default "__VITE_ASSET__IO5QWxg$__"